import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { monkLanguages } from '@monkvision/types';
import en from './translations/en.json';
import fi from './translations/fi.json';
import cs from './translations/cs.json';
import no from './translations/no.json';
import ro from './translations/ro.json';
import pl from './translations/pl.json';
import da from './translations/da.json';
import sv from './translations/sv.json';
import es from './translations/es.json';
import pt from './translations/pt.json';
import fr from './translations/fr.json';
import de from './translations/de.json';
import nl from './translations/nl.json';
import it from './translations/it.json';
import enIE from './translations/en-IE.json';
import enGB from './translations/en-GB.json';
import enHag from './translations/en-hag.json';

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v3',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    supportedLngs: monkLanguages,
    nonExplicitSupportedLngs: true,
    resources: {
      'en': { translation: en },
      'fr': { translation: fr },
      'de': { translation: de },
      'nl': { translation: nl },
      'it': { translation: it },
      'pt': { translation: pt },
      'es': { translation: es },
      'sv': { translation: sv },
      'da': { translation: da },
      'pl': { translation: pl },
      'ro': { translation: ro },
      'no': { translation: no },
      'cs': { translation: cs },
      'fi': { translation: fi },
      'en-IE': { translation: enIE },
      'en-GB': { translation: enGB },
      'en-hag': { translation: enHag },
      'en-HAG': { translation: enHag },
    },
  })
  .catch(console.error);

export default i18n;
